import nationalitiesReducer from "./reducers";
export { default as nationalitiesTypes } from "./types";
export { default as nationalitiesOperations } from "./operations";
export default nationalitiesReducer;
